<template lang="pug">
.comparison
  #comArea.comAll(v-dragDiv,v-show="!actionData.isMini")
    .title.moveDragDiv
      span {{actionData.cnName}}
      el-button(size='mini' plain='' @click='openTree') 选择其他文件
      i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
      i.el-icon-close.closebtn(title='关闭' @click='closeCom')
    .contentCom(v-loading='loading' element-loading-text='对比数据请求中...')
      el-table(ref='multipleTable' :data='tableData' tooltip-effect='dark' style='width: 100%' border)
        el-table-column(prop='name' label='图纸名称' show-overflow-tooltip='')
        el-table-column(prop='version' label='版本号' align='center')
          template(#default='{row}')
            span {{row.version}}
            span(v-if='row.version == fileVersion') （底图）
        el-table-column(prop='operDate' label='更新时间' align='center' width='140px')
        el-table-column(label='操作' align='center')
          template(#default="{row}")
            el-button(size='mini',type='text',:disabled="row.status != 2&&row.status != 6",v-if="row.version !== fileVersion",@click='contrastFile(row)') 版本对比
      .footer
        el-button(size='mini' @click='cancel') 取消对比
  #legendCom(v-if='legendBoolean')
    .common(v-for='(item,index) in legendList' :key='index')
      span.logo(:style='{backgroundColor:item.color}')
      span(:style='{color:item.color}') {{item.name}}
  el-dialog(title='选择文件' :modal='false' append-to-body='' width='400px' :before-close='handleClose' :visible.sync='contrastFlag')
    el-tree(
      v-if='contrastFlag',
      v-loading='treeLoading',
      style='height:300px;overflow-y:auto',
      :props='defaultProps',
      :default-expanded-keys='unfoldIdArr',
      check-on-click-node,
      :load='loadNode',
      accordion,
      :check-strictly='true',
      highlight-current,
      node-key='folderId',
      lazy, show-checkbox,
      @check='handleCheckChange',
      @node-click='clickNodeTree')
      template(#default='{ node,data }')
        span.treeStyle
          img(:src='folder_icon(data)' alt='图标')
          span {{ node.label }}
    span.dialog-footer(slot='footer')
      el-button(size='mini' type='primary' @click='sureFile') 确 定
      el-button(size='mini' @click='handleClose') 取 消
</template>

<script>
const requestTypeList = () => ({
  EnterpriseDoc: 'enterpriseDocTree',
  MyDoc: 'personalDocTree',
  EnterpriseDeptDoc: 'enterpriseDeptDocTree'
});
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      legendList: [
        { name: '新增', color: '#03ff00' },
        { name: '重合', color: '#cccc00' },
        { name: '删除', color: '#d9001c' }
      ],
      contrastFlag: false,
      treeLoading: false,
      defaultProps: { children: 'children', label: 'folderName', isLeaf: 'leaf' }, // 树形结构
      unfoldIdArr: [],
      otherDwgId: []
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    legendBoolean() {
      return mongeApp.legendBoolean;
    },
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    argnmentParams() {
      const argument = {
        folderId: '0',
        prjId: this.dwgdata.prjId,
        enterpriseId: this.dwgdata.enterpriseId,
        isRead: 1,
        isNew: '',
        priviAll: '1',
        versionId: '',
        versionName: "",
        isPersonal: '',
        flag: false
      };
      return argument;
    },
    fileVersion() {
      return Number(this.dwgdata.fileVersion);
    }
  },
  mounted() {
    this.queryVersions();
  },
  methods: {
    async queryVersions() {
      try {
        this.loading = true;
        const res = await mongeService.queryDetail(this.dwgdata.fileId);
        this.tableData = res.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    miniCom() {
      this.$emit('closeCom', 'comparison', true);
    },
    closeCom() {
      this.$emit('closeCom', 'comparison', false);
    },
    cancel() {
      mongeApiMlib.cancelMapCompare();
      mongeMutations.openLegend(false);
    },
    openTree() {
      this.contrastFlag = true;
    },
    contrastFile(row) {
      if (row.version == this.fileVersion) {
        return this.$message.warning("不能与本版本图纸进行对比");
      }
      this.loading = true;
      this.contrastRequest(row.fileId, row.version);
    },
    async contrastRequest(fileId, fileVersion) {
      this.picsdata = [];
      if (this.mlibEnabled) {
        const res = await mongeService.queryModelLightFilesFromMLib(fileId, fileVersion);
        const utlList = await mongeApiMlib.dealMongeFiles(res.data || {});
        if (utlList) {
          const picsurl = utlList.find(e => e.fileName == JSON.parse(this.spaceOfDwgData));
          this.contrastCompare(picsurl);
        } else {
          this.loading = false;
        }
      } else {
        const res = await mongeService.queryDwgSpace(fileId, fileVersion);
        const utlList = mongeApiMlib.assembleUrl(res.data);
        const picsurl = utlList.find(e => e.picName == JSON.parse(this.spaceOfDwgData))?.picsurl;
        this.contrastCompare(picsurl);
      }
    },
    async contrastCompare(picsurl) {
      await mongeApiMlib.mapCompare(picsurl);
      this.loading = false;
      mongeMutations.openLegend(true);
    },
    handleClose() {
      this.contrastFlag = false;
    },
    handleCheckChange(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
      this.otherDwgId = checkedKeys.checkedNodes || [];
    },
    async clickNodeTree(data, node) {
      this.publicOpenFolder(data, node);
    },
    publicOpenFolder(data, node) {
      this.unfoldIdArr = [];
      this.loadNode(node);
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const prjId = this.dwgdata.prjId;
        const requestType = requestTypeList()[prjId] ? requestTypeList()[prjId] : 'queryTree';
        if (requestType === 'queryTree') delete this.argnmentParams.enterpriseId;
        const result = await mongeService[requestType](this.argnmentParams);
        const filterData = [];
        result.data.forEach(item => {
          item.disabled = true;
          if (item.folderId !== 'recycle' && item.folderId !== 'MyCollection' && item.folderId !== 'MySend') { // 去掉回收站,我的分享和我的收藏
            filterData.push(item);
          }
        });
        typeof resolve === 'function' && resolve(filterData);
        this.treeLoading = false;
      } else {
        this.getChildren(node, resolve);
      }
    },
    async getChildren(node, resolve) {
      const prjId = this.dwgdata.prjId;
      const folderId = node.data.folderId;
      const params = {
        ...this.argnmentParams,
        folderId: folderId
      };
      const requestType = requestTypeList()[prjId] ? requestTypeList()[prjId] : 'queryTree';
      if (requestType === 'queryTree') delete params.enterpriseId;
      const res = await mongeService[requestType](params);
      const data = res.data.filter(item => item.isFolder === 1 || item.fileType === 8);
      data.forEach(item => {
        if (item.isFolder === 1) {
          item.children = [];
          item.leaf = false;
          item.disabled = true;
        } else if (item.isFolder === 1 && item.fileType === 8) {
          item.leaf = true;
        } else if (item.isFolder === 0 && item.fileType === 8 && !(item.status === '2' || item.status === '6')) {
          item.disabled = true;
        }
      });
      typeof resolve === 'function' && resolve(data);
    },
    sureFile() {
      if (this.otherDwgId.length == 1) {
        this.contrastFlag = false;
        this.loading = true;
        this.contrastRequest(this.otherDwgId[0]?.folderId, this.otherDwgId[0]?.fileVersion);
      } else if (this.otherDwgId.length > 1 || this.otherDwgId.length == 0) {
        this.$message.warning("请选择一张图纸对比");
      }
    },
    folder_icon(data) {
      let imgIcon;
      if (data.fileType == 8) {
        imgIcon = require("../images/dwg.png");
      } else {
        imgIcon = require("../images/tableZiDoc.png");
      }
      return imgIcon;
    }
  }

};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#comArea{
  position:absolute;
  bottom: 95px;
  left :calc(50% - 290px);
  width :580px;
  height: 450px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .contentCom{
    flex: 1;
    padding: 10px 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .el-table{
      flex: 1;
      overflow-y: auto;
    }
    .footer{
      height: 30px;
      width: 100%;
      padding: 0 20px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
    }
  }
}
#legendCom{
  border: 1px solid #fff;
  width: 150px;
  height: 90px;
  border-radius: 5px;
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  z-index: 4;
  .common{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .logo{
      width: 60px;
      height: 14px;
      border-radius: 5px;
      margin-right: 10px;
    }
  }
}
/deep/ .el-tree-node__content{
  display: flex;
  flex-direction: row;
  align-items: center;
  .treeStyle{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight:400;
    >img{
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
    >span{
      font-size: 12px;
    }
  }
}
</style>
